module.exports = new __parcel__URL__("los_angeles_banner.276d55f8.jpg").toString();